import { styled, useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledBox = styled(Box)(() => {
  const theme = useTheme();

  return {
    width: '100%',
    height: '100vh',
    display: 'grid',
    gridTemplateColumns: '68px 1fr',
    overflowX: 'hidden',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
    },
  };
});
